import createElement from '../logical-components/createElement';
import renderText from '../logical-components/renderText';
import './scss/poweredBy.scss';
// Simple section for the powered by footer
var PoweredBy = function () {
    var wrapper = createElement('div', [
        { type: 'class', value: '_mnslq-poweredby' },
    ]);
    wrapper.innerHTML = renderText('footer.mensenlinq', 'https://mensenlinq.nl/');
    return wrapper;
};
export default PoweredBy;
